import "./Home.module.css";
import NavegaciNPrincipal from "@/reusable_sections/Header";
import LaExcelenciaEnSaludCapilar from "./sections/LaExcelenciaEnSaludCapilar";
import GarantADeExcelenciaMDica from "./sections/GarantADeExcelenciaMDica";
import NuestrasEspecialidades from "./sections/NuestrasEspecialidades";
import ElCompromisoDeLaDraSoto from "./sections/ElCompromisoDeLaDraSoto";
import WhyChooseUs from "./sections/WhyChooseUs";
import TuCambioComienzaAqu from "./sections/TuCambioComienzaAqu";
import PieDePGinaInstitucional from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <NavegaciNPrincipal />
      <LaExcelenciaEnSaludCapilar />
      <GarantADeExcelenciaMDica />
      <NuestrasEspecialidades />
      <ElCompromisoDeLaDraSoto />
      <WhyChooseUs />
      <TuCambioComienzaAqu />
      <PieDePGinaInstitucional />
    </div>;
}